import { Link } from "react-router-dom"
import FadeInWhenInView from "../../../animations/FadeInWhenInView"
import { ProjectType } from "../../../io/projects_api"
import HoverVideo from "../../../common/HoverVideo"

const Project = ({project}: {project: ProjectType}) => {


    return(
            <Link to={'/project/' + project.id} className="cursor-fancypointer_w active:cursor-fancyactive_b">
                <div className="min-w-48 md:min-w-60 lg:min-w-72 xl:min-w-[32rem] flex flex-col">
                    <FadeInWhenInView delay={((project.id-1)%2)/6} margin={0.2}>
                        <div className="bg-gray rounded-xl w-full aspect-square border-solid border-darkgray dark:border-gray border-[1px]" >
                        <HoverVideo src={project.anim} preview={project.small_title_img_url}/>
                        </div>
                    </FadeInWhenInView>
                        <div className="flex flex-col">
                            <FadeInWhenInView delay={((project.id-1)%2)/2} margin={-1}>
                                <div className="w-full flex justify-end uppercase dark:text-gray text-darkgray py-2">
                                    <div className="px-2 py-[1px] md:px-4 md:py-[2px] text-xs border-solid border-darkgray dark:border-gray border-[1px] rounded-md" style={{fontSize: '1rem'}}>
                                        <div className="text-xs md:text-md lg:text-lg xl:text-xl">{project.project_type}</div>
                                    </div>
                                </div>
                            </FadeInWhenInView>
                            <div className="flex flex-col gap-2 lg:gap-8 uppercase">
                                <FadeInWhenInView delay={((project.id-1)%2)/6} margin={0.1}><div className="font-semibold text-sm md:text-lg lg:text-xl xl:text-3xl">{project.title}</div></FadeInWhenInView>
                                <FadeInWhenInView delay={((project.id-1)%2)/6} margin={0.1}>
                                    <div className="text-[0.6rem] md:text-md lg:text-lg xl:text-xl text-gray">
                                    
                                            {project.subtitle}
                                    </div>
                                </FadeInWhenInView>
                            </div>
                        </div>
                </div>
            </Link>
    )
}

export default Project